/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of NonH5Plugin
 */

import { IPlugin } from 'com/didichuxing/plugin/IPlugin';
import { IContext } from 'com/didichuxing/context/IContext';

export default class NonH5Plugin implements IPlugin {

    /**
     * test安装状态
     */
    private installed: boolean;

    /**
     * 上下文
     */
    private context: IContext;

    /**
     * @constructor
     */
    constructor(context: IContext) {
        this.installed = false;
        this.context = context;
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getName(): string {
        return 'non-h5-plugin';
    }

    /**
     * @override
     * @inheritDoc
     * @returns {IContext}
     */
    public getContext(): IContext {
        return this.context;
    }

    /**
     * @override
     * @inheritDoc
     * @returns {boolean}
     */
    public install(): boolean {
        this.installed = true;
        return this.installed;
    }

    /**
     * @override
     * @inheritDoc
     * @returns {boolean}
     */
    public hasInstalled(): boolean {
        return this.installed;
    }

    /**
     * @override
     * @inheritDoc
     */
    public execute(): void {
        /* Nothing to execute */
    }

    /**
     * @override
     * @inheritDoc
     */
    public exit(): void {
        /* Nothing to exit */
    }

    /**
     * 插件卸载。
     * @returns {boolean}
     */
    public uninstall(): boolean {
        this.exit();
        this.installed = false;
        delete this.context;
        return true;
    }
}
